module.exports = __webpack_public_path__ + "static/media/C_E03.a4658c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GREEN/C_E03.png
// module id = 96
// module chunks = 0